import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'

import Banner from '../../components/banner'
import Layout from '../../components/layouts/mainLayout'
import Head from '../../components/head'
import Gallery from '../../components/gallery'

const Gallery2K18 = () => {

    const data = useStaticQuery(graphql`
        query {
            gallery: allFile (filter: {sourceInstanceName: {eq: "gallery-2018"}}
            sort: {fields: relativePath} 
            ){
                edges {
                    node {
                        ...FluidImageFragment
                    }
                }
            }
        }
    `)

    return (

        <Layout>
            <Head title="2018 Gallery"/>
            <Gallery data={data.gallery.edges} />
        </Layout>
        
    )
}

export default Gallery2K18